import axios from "axios";
import { IPriceList } from "../type/IPriceList";
import { EnumEndpoint } from "../type/EnumEndpoint";

export const getPriceList = () => {
  return axios.get<IPriceList>(EnumEndpoint.PRICES).catch((err) => {
    console.log(err);
    return { data: undefined }
  });
}